import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
/**
 * Hook para gerenciar vídeos com captura de leads (VSLeads)
 */

import { useState, useEffect } from 'react';
import { vsleadsService, VSLeadVideoSimplified } from '@/services/vsleadsService';

export const useVSLeadsVideos = (userId: string | null) => {
  useLanguage();
  const [videos, setVideos] = useState<VSLeadVideoSimplified[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchVideos = async () => {
      if (!userId) {
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const fetchedVideos = await vsleadsService.getVideosWithLeadCapture(userId);
        setVideos(fetchedVideos);
      } catch (err: any) {
        console.error('Erro ao buscar vídeos VSLeads:', err);
        setError(err?.message || translateInterfaceText("Erro ao carregar vídeos com captura de leads"));
        setVideos([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVideos();
  }, [userId]);

  return {
    videos,
    isLoading,
    error,
    refetch: async () => {
      if (userId) {
        setIsLoading(true);
        try {
          const fetchedVideos = await vsleadsService.getVideosWithLeadCapture(userId);
          setVideos(fetchedVideos);
          setError(null);
        } catch (err: any) {
          setError(err?.message || translateInterfaceText("Erro ao carregar vídeos"));
        } finally {
          setIsLoading(false);
        }
      }
    },
  };
};
